import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'react-bootstrap';
import { useCurrencyFormatter } from '../../../../../hooks/useCurrencyFormatter';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';
import {
  getIcon,
  getStatusVariant,
  getStatusLabel,
  ExpenseItem,
} from './expenseTileUtils';

type ExpenseTileHeaderProps = {
  item: ExpenseItem;
  amount: number;
  onDeleteClick?: (e: React.MouseEvent) => void;
  showDelete: boolean;
  onClick: () => void;
};

export const ExpenseTileHeader: React.FC<ExpenseTileHeaderProps> = ({
  item,
  amount,
  onDeleteClick,
  showDelete,
  onClick,
}) => {
  const { t } = useTranslation();
  const formatCurrency = useCurrencyFormatter();

  return (
    <div className="expense-tile-main" onClick={onClick}>
      <div className="expense-tile-icon">
        <FlairIcon icon={getIcon(item)} size="lg" />
      </div>

      {showDelete && onDeleteClick && (
        <div className="expense-tile-delete-btn-container">
          <button
            className="expense-tile-delete-btn"
            onClick={onDeleteClick}
            title={
              item.isGroup
                ? t('expenses.groups.deleteExpenseGroup')
                : t('expenses.deleteExpense')
            }>
            <FlairIcon icon="trash-outline" size="sm" />
          </button>
        </div>
      )}

      <div className="expense-tile-content">
        <div className="expense-tile-header">
          <h6 className="expense-tile-name">{item.Name}</h6>
          <div className="me-4">
            <Badge
              bg={getStatusVariant(
                item.flair__Status__c,
                item.flair__Reimbursed__c,
              )}
              className="expense-tile-status">
              {getStatusLabel(
                item.flair__Status__c,
                t,
                item.flair__Reimbursed__c,
              )}
            </Badge>
          </div>
          <div className="expense-tile-right">
            <div className="expense-tile-amount me-3">
              {formatCurrency({
                value: amount,
                currency: item.CurrencyIsoCode,
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
